import $ from "./ajax.js";
import { Toast } from "antd-mobile";

export const errorHandler = (xhr, status, err) => {
  console.log(xhr, status, err);

  if (xhr.status === 400) {
    Toast.fail("request error: " + err);
    return;
  }
  if (xhr.status === 401) {
    // 登出，并跳转至登录页
    logout();
  }

  if (xhr.status === 403) {
    Toast.fail("access denied");
    return;
  }
  if (xhr.status === 404) {
    Toast.fail("url no found");
    return;
  }
  if (xhr.status >= 500) {
    Toast.fail("server error: " + err);
    return;
  }
  if (xhr.status > 404) {
    Toast.fail("unknown error: " + err);
  }
};

export const logout = () => {
  window.location = "/tsp/j_spring_security_logout";
};

//获取故障代码菜单
// export const getMenu = () => $.ajax({
//     guid: "geMenu",
//     url: "/tsp/api/v1/system/error-code/errorCodeCategory/menu/",
//     showError:true,
//     type: "GET",
//     async: true,
//     header: {
//         "Accept": "application/json",
//     },
//     success: function (res) {
//         console.log(res.data);
//     },
//     error: errorHandler
// });
//获取故障代码菜单 2.0
export const getMenu = (language) =>
  $.ajax({
    guid: "geMenu",
    url: "/tsp/ibos/web/tspApi/errorCodeCategory/getByParentId",
    showError: true,
    type: "GET",
    async: true,
    header: {
      Accept: "application/json",
    },
    data: {
      language: language,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });

//获取故障代码分类
export const getMenuList = (id, language) =>
  $.ajax({
    guid: "getMenuList",
    showError: true,
    url: "/tsp/ibos/web/tspApi/errorCodeCategory/getByParentId",
    type: "GET",
    async: true,
    header: {
      Accept: "application/json",
    },
    data: {
      parentId: id,
      language: language,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });

//根据故障代表表头Id获取故障代码表信息
// export const getTabledata = (errorCodeListId) => $.ajax({
//     guid: "getTabledata",
//     showError:true,
//     url: "/tsp/api/v1/system/error-code/errorCode/" + errorCodeListId,
//     type: "GET",
//     async: true,
//     header: {
//         "Accept": "application/json",
//     },
//     success: function (res) {
//         console.log(res.data);
//     },
//     error: errorHandler
// });
export const getProductBymodel = (customerModel) =>
  $.ajax({
    showError: true,
    url: "/tsp/ibos/web/tspApi/product/customer/list",
    type: "POST",
    async: true,
    contentType: "application/json",
    dataType: "json",
    header: {
      Accept: "application/json",
    },
    data: {
      customerModel: customerModel,
      productStatus: "3",
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });
export const getProductBySn = (productSerial) =>
  $.ajax({
    showError: true,
    url: "/tsp/ibos/web//tspApi/productShip/getProductBySnCode",
    type: "POST",
    async: true,
    contentType: "application/json",
    dataType: "json",
    header: {
      Accept: "application/json",
    },
    data: {
      productSerial: productSerial,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });
export const getTabledata = (errorCodeListId, language, categoryId) =>
  $.ajax({
    guid: "getTabledata",
    showError: true,
    url: "/tsp/ibos/web/tspApi/errorCode/detail/query",
    type: "POST",
    async: true,
    contentType: "application/json",
    dataType: "json",
    header: {
      Accept: "application/json",
    },
    data: {
      language: language,
      listId: errorCodeListId,
      categoryId: categoryId,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });

//根据产品编码获取故障代码表信息
// export const getTabledatabycode = (productCode) => $.ajax({
//     guid: "getTabledatabycode",
//     showError: true,
//     url: "/tsp/api/v1/system/error-code/product/" + productCode,
//     type: "GET",
//     async: true,
//     header: {
//         "Accept": "application/json",
//     },
//     success: function (res) {
//         console.log(res.data);
//     },
//     error: errorHandler
// });
export const getTabledatabycode = (productCode) =>
  $.ajax({
    guid: "getTabledatabycode",
    showError: true,
    url: "/tsp/ibos/web/tspApi/errorCodeList/getById/" + productCode,
    type: "GET",
    async: true,
    header: {
      Accept: "application/json",
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });

//GET  故障代码解决方案
// export const geterrorCodeSolution = (solutionId) => $.ajax({
//     guid: "geterrorCodeSolution",
//     showError:true,
//     url: "/tsp/api/v1/system/error-code/errorCodeSolution/",
//     type: "GET",
//     async: true,
//     data: {
//         solutionId: solutionId,
//     },
//     success: function (res) {
//         console.log(res.data);
//     },
//     error: errorHandler
// });
export const geterrorCodeSolution = (solutionId, language) =>
  $.ajax({
    guid: "geterrorCodeSolution",
    showError: true,
    url: "/tsp/api/v1/anonymity/error-code/solution/" + solutionId,
    type: "GET",
    async: true,
    data: {
      language: language,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });
export const preView = (fileGuid) =>
  $.ajax({
    showError: true,
    url: "/tsp/ibos/web/tspApi/preView",
    type: "GET",
    async: true,
    data: {
      loginId: "yubin29",
      fileGuid: fileGuid,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });
export const getPath = (id) =>
  $.ajax({
    showError: true,
    url: "/tsp/ibos/web/tspApi/guest/downLoadInfo?fileGuId=" + id,
    type: "GET",
    async: true,
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });
export const getPath2 = (fileGuid) =>
  $.ajax({
    showError: true,
    url: "/tsp/ibos/web/tspApi/macroFilePdf",
    type: "GET",
    async: true,
    data: {
      fileGuid: fileGuid,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });

export const getDocDownloadUrl = (docId) => {
  return "/tsp/api/v1/anonymity/doc/" + docId;
};

//根据solutionId,language获取语言版本附件信息
// export const getLanguageVerionBy = (solutionId,language) => $.ajax({
//     guid: "getLanguageVerionBy",
//     showError:true,
//     url: "/tsp/api/v1/system/error-code/errorCodeSolution/getLanguageVerionBy",
//     type: "GET",
//     async: true,
//     data: {
//         solutionId: solutionId,
//         language:language
//     },
//     success: function (res) {
//         console.log(res.data);
//     },
//     error: errorHandler
// });
export const getLanguageVerionBy = (solutionId, language) =>
  $.ajax({
    guid: "getLanguageVerionBy",
    showError: true,
    url: "/tsp/api/v1/anonymity/error-code/solution/language/" + solutionId,
    type: "GET",
    async: true,
    data: {
      language: language,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });

//获取头信息
// export const getheadermsg = (errorCodeListId) => $.ajax({
//     showError:true,
//     guid: "geterrorCodeSolution",
//     url: "/tsp/api/v1/system/error-code/errorCodeList/"+errorCodeListId,
//     type: "GET",
//     async: true,
//     success: function (res) {
//         console.log(res.data);
//     },
//     error: errorHandler
// });
export const getheadermsg = (errorCodeListId, language) =>
  $.ajax({
    showError: true,
    guid: "geterrorCodeSolution",
    url: "/tsp/ibos/web/tspApi/errorCodeList/getById",
    type: "GET",
    async: true,
    data: {
      language: language,
      id: errorCodeListId,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });
//获取指定客户型号客版产品列表
export const customerModel = (customerModel) =>
  $.ajax({
    showError: true,
    guid: "getcustomerModel",
    url: "/tsp/api/v1/anonymity/product/customer/model/" + customerModel,
    type: "GET",
    async: true,
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });

//将相关埋点信息发送给日志服务器
export const getLog = (currentUrl, appId, pointName) =>
  $.ajax({
    showError: true,
    guid: "getLog",
    url: "/tsp/ibos/web/tsp/api/v1/log",
    type: "GET",
    async: true,
    data: {
      currentUrl: currentUrl,
      appId: appId,
      pointName: pointName,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });

//获取语言列表
export const getLanguageList = (typeCode) =>
  $.ajax({
    showError: true,
    guid: "getLanguageList",
    url: "/tsp/ibos/web/tspApi/dict/value/get",
    type: "GET",
    async: true,
    data: {
      typeCode: typeCode,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });
//获取故障代码表查询
export const getCodeTableList = (id, language, buId, type) =>
  $.post({
    showError: true,
    url: "/tsp/ibos/web/tspApi/errorCodeList/get/list",
    type: "POST",
    contentType: "application/json",
    dataType: "json",
    data: {
      categoryId: id,
      buId: buId,
      language: language,
      hasErrorCode: "1",
      type: type,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });
//获取故障代码表查询通过产品id
export const getCodeTableListByProductId = (id, language, buId) =>
  $.get({
    showError: true,
    url: "/tsp/ibos/web/tspApi/errorCodeList/getByProductId",
    type: "get",
    contentType: "application/json",
    dataType: "json",
    data: {
      productId: id,
      language: language,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });
//获取故障代码表查询通过产品code
export const getCodeTableListByProductCode = (id, language, buId) =>
  $.get({
    showError: true,
    url: "/tsp/ibos/web/tspApi/errorCodeList/getByProductCode",
    type: "get",
    contentType: "application/json",
    dataType: "json",
    data: {
      productCode: id,
      language: language,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });
//获取故障代码表查询通过code
export const getCodeTableListBycode = (id, language) =>
  $.post({
    showError: true,
    url: "/tsp/ibos/web/tspApi/errorCode/detail/query",
    type: "POST",
    contentType: "application/json",
    dataType: "json",
    data: {
      language: language,
      code: id,
    },
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });

export const getBlobUrl = (fileGuid) =>
  $.ajax({
    showError: true,
    url: "/tsp/ibos/web/tspApi/macroFilePdf",
    type: "GET",
    async: true,
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    responseType: "blob",
    responseHead: true,
    data: {
      fileGuid: fileGuid,
    },
    success: function (res) {
      console.log(res.data);
      // console.log("ss", res);
      // const blob = res;
      // const reader = new FileReader();
      // reader.readAsDataURL(blob);
      // reader.onload = (e) => {
      //   let href = window.URL.createObjectURL(blob); //创建下载的链接
      //   console.log("href", href);
      //   // callback && callback(href);
      // };
    },
    error: errorHandler,
  });
//获取解决方案详情
export const getErrorCodeSolutionDetail = (id, language) =>
  $.post({
    showError: true,
    url: "/tsp/ibos/web/tspApi//errorCodeSolution/getById?id=" + id,
    type: "POST",
    contentType: "application/json",
    dataType: "json",
    data: {},
    success: function (res) {
      console.log(res.data);
    },
    error: errorHandler,
  });



// WEBPACK FOOTER //
// ./src/ajax/index.js